import {
  MenuItem,
  Select,
  InputLabel,
  TextField,
  Checkbox,
  ListItemIcon,
  ListItemText,
  Grid,
  Button,
} from "@material-ui/core";
import { getToday } from "../utils/varialbles";
import { makeStyles } from "@material-ui/core/styles";
let statusArray = {
  I: "Interested",
  N: "Not Interested",
  L: "Later",
  O: "No Answer",
  S: "No Status",
};

const useStyles = makeStyles({
  root: {
    width: "100%",
  },
  table: {
    field: "Resizing",
    title: "Column Width",
    cellStyle: {
      whiteSpace: "nowrap",
      width: "20%",
    },
  },
  indeterminateColor: {
    color: "#f50057",
  },
  selectAllText: {
    fontWeight: 500,
  },
  selectedAll: {
    backgroundColor: "rgba(0, 0, 0, 0.08)",
    "&:hover": {
      backgroundColor: "rgba(0, 0, 0, 0.08)",
    },
  },
  radio: {
    "&$checked": {
      color: "#57bf74",
    },
  },
  checked: {},
});
function Filter({
  columns,
  applyFilter,
  orignalRows,
  handleChange,
  formObject,
  clearFilter,
  onClick,
  closeFilter
}) {
  const classes = useStyles();
  // onClick(null);
  let curr = new Date();
  curr.setDate(curr.getDate());
  let getCurrentdate = curr.toISOString().substring(0, 10);


  return (
    <div className={["menupopupfilter", "filter"].join(" ")}>
      <div
        style={{ width: 30, height: 30, borderRadius: '50%', lineHeight: '30px', display: 'flex', justifyContent: 'center', fontWeight: 'bold', cursor: 'pointer', background: '#ddd', margin: '5px 0 0 5px' }}

        onClick={closeFilter}
      >
        X
      </div>
      {columns
        .filter((obj) => {
          return obj.filter === true;
        })
        .map((obj, inx) => {
          return (
            <div
              key={inx + "filter" + "prospect"}
              style={{ marginLeft: 20, paddingBottom: 10, paddingTop: 10 }}
            >
              <div>
                <InputLabel style={{ color: "black" }}>{obj.label}</InputLabel>
              </div>
              <div style={{ paddingTop: 10 }}>
                {obj.filterType === "date" ? (
                  <>
                    <Select
                      value={formObject[obj.id + "__condition"] || ""}
                      onChange={handleChange}
                      name={obj.id + "__condition"}
                      className="select"
                      label={obj.label + " Condition"}
                      style={{
                        backgroundColor: "white",
                        marginBottom: 10,
                      }}
                      variant="outlined"
                    >
                      {obj["conditions"].map((sub) => {
                        return (
                          <MenuItem value={sub.value}>{sub.text}</MenuItem>
                        );
                      })}
                    </Select>
                    <TextField
                      id={obj.id}
                      type="date"
                      variant="outlined"
                      InputLabelProps={{
                        shrink: true,
                      }}
                      format="YYYY-MM-DD"
                      value={formObject[obj.id] || ""}

                      inputProps={{
                        // min: "2020-08-10",
                        max: getCurrentdate
                      }}
                      onChange={handleChange}
                      name={obj.id}
                      className="select"
                      style={{
                        backgroundColor: "white",
                      }}
                    />
                  </>
                ) : obj.filterType === "dropDown" &&
                  obj.options &&
                  Array.isArray(obj.options) &&
                  obj.options.length > 0 ? (
                  <Select
                    displayEmpty
                    id={obj.id}
                    value={formObject[obj.id] || (obj.multi ? [] : "")}
                    onChange={handleChange}
                    name={obj.id}
                    className="select"
                    variant="outlined"
                    multiple={obj.multi}
                    renderValue={(selected) => {
                      return obj.multi && obj.id === "status"
                        ? selected.map((s) => statusArray[s]).join(",")
                        : obj.multi
                          ? selected.join("")
                          : selected;
                    }}
                    style={{
                      backgroundColor: "white",
                    }}
                  >
                    {obj.options.map((sub, sinx) => {
                      return obj.multi ? (
                        <MenuItem key={sinx + sub.value.trim} value={sub.value}>
                          <ListItemText primary={sub.text} />
                          <ListItemIcon>
                            <Checkbox
                              classes={{
                                root: classes.radio,
                                checked: classes.checked,
                              }}
                              checked={
                                formObject[obj.id] &&
                                formObject[obj.id].indexOf(sub.value) > -1
                              }
                            />
                          </ListItemIcon>
                        </MenuItem>
                      ) : (
                        <MenuItem value={sub.value}>{sub.text}</MenuItem>
                      );
                    })}
                  </Select>
                ) : obj.filterType === "dropDown" &&
                  obj.options &&
                  obj.options === "data" ? (
                  <Select
                    displayEmpty
                    id={obj.id}
                    value={formObject[obj.id] || (obj.multi ? [] : "")}
                    onChange={handleChange}
                    name={obj.id}
                    className="select"
                    variant="outlined"
                    multiple={obj.multi}
                    renderValue={(selected) => {
                      return obj.multi ? selected.join(",") : selected;
                    }}
                    style={{
                      backgroundColor: "white",
                    }}
                  >
                    {orignalRows
                      .map((sub) => sub[obj.id])
                      .filter(
                        (value, index, self) => self.indexOf(value) === index
                      )
                      .map((val) => {
                        return obj.multi ? (
                          <MenuItem value={val}>
                            <ListItemText primary={val} />
                            <ListItemIcon>
                              <Checkbox
                                classes={{
                                  root: classes.radio,
                                  checked: classes.checked,
                                }}
                                checked={
                                  formObject[obj.id] &&
                                  formObject[obj.id].indexOf(val) > -1
                                }
                              />
                            </ListItemIcon>
                          </MenuItem>
                        ) : (
                          <MenuItem value={val}>{val}</MenuItem>
                        );
                      })}
                  </Select>
                ) : obj.filterType && obj.filterType === "number" ? (
                  <>
                    <Select
                      value={formObject[obj.id + "__condition"] || ""}
                      onChange={handleChange}
                      name={obj.id + "__condition"}
                      className="select"
                      label={obj.label + " Condition"}
                      style={{
                        backgroundColor: "white",
                        marginBottom: 10,
                      }}
                      variant="outlined"
                    >
                      {obj["conditions"].map((sub) => {
                        return (
                          <MenuItem value={sub.value}>{sub.text}</MenuItem>
                        );
                      })}
                    </Select>
                    <TextField
                      id={obj.id}
                      type="number"
                      variant="outlined"
                      InputLabelProps={{
                        shrink: true,
                      }}
                      format="YYYY-MM-DD"
                      value={formObject[obj.id] || ""}
                      onChange={handleChange}
                      name={obj.id}
                      className="select"
                      style={{
                        backgroundColor: "white",
                      }}
                    />
                  </>
                ) : (
                  ""
                )}
              </div>
            </div>
          );
        })}
      <div
        style={{
          float: "right",
          paddingBottom: 10,
          paddingRight: 40,
          paddingTop: 10,
          display: "flex",
          justifyContent: "flex-end",
          columnGap: 20,
        }}
      >
        <Button variant="contained" onClick={applyFilter} color="primary">
          Apply
        </Button>
        <Button variant="contained" onClick={clearFilter} color="default">
          Clear
        </Button>
      </div>
    </div>
  );
}

export default Filter;
